import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { getAccessToken, hasAccessToken } from "../../constants/auth";

class Splash extends Component {
  componentDidMount() {
    if (hasAccessToken()) {
      this.props.updateLoginProps([{ prop: "token", value: getAccessToken() }]);
      this.props.history.push("/home");
    } else {
      this.props.history.push("/login");
    }
  }
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">Hello</Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ loginReducer }) => ({
  loginReducer
});

export default connect(
  mapStateToProps,
  actions
)(Splash);
